<template>
  <div>
    <v-card class="custom-buttons-holder">
      <v-container fluid>
        <v-row justify="end" >
          <v-col cols="3">
            <v-select class="mt-8"
              v-model="year"
              :items="orderedYearsWithAll"
              outlined
              @change="yearChange"
              menu-props="auto"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="3">

          <label>Farbe</label>

          <v-select class="mt-3"
          v-model="selectedColor"
          :items="colorOptions"
          item-value="value"
          hide-details
          outlined
          @change="colorChange"

          ></v-select>
        </v-col>

          <v-col cols="6">
            <v-row class="first-row">
              <v-col cols="2" v-if="!hideFilters">
                <a href="#" class="filter" @click="filtersTrigger">
                  <img class="custom-map-area-icon" src="../../../assets/images/icons/filter.svg" />
                  <span>Filter</span>
                </a>
              </v-col>
              <v-col cols="2" v-if="!hideFilters">
                <a class="carte" @click="viewSelectedItemOnMap" >
                  <img
                    class="karte mr-2"
                    src="../../../assets/images/map.png"
                    alt=""
                  /><span>Karte</span>
                  <div class="information" v-if="showInfo">
                    Sie müssen mindestens einen Baum oder ein Gebiet auswählen.
                  </div>
                </a>
              </v-col>
              <v-col cols="6">
                <v-btn
                  v-if="userCanEdit"
                  block
                  size="x-large"
                  height="54px"
                  color="#1db954"
                  class="new-btn"
                  @click="createNewTask"
                >
                  <v-icon>mdi mdi-plus-thick</v-icon>
                  Neue Pflegemassnahme
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="filters-row mt-10" v-show="showFilters">
          <v-col cols="12" class="filters-holder">
            <div class="from-to-dates">
              <p class="custom-label">Datum</p>

              <div class="fields">
                <DateInput v-model="fromDate"
                           :text-field-props="{clear: onClearDateFrom}"
                           :date-picker-props="{max: toDate}"
                           key="fromDate"/>
                <DateInput v-model="toDate"
                           :text-field-props="{clear: onClearDateTo}"
                           :date-picker-props="{min: fromDate}"
                           key="toDate"/>
              </div>
            </div>

            <div class="from-to-tree">
              <p class="custom-label">Baum ID interval</p>
              <div class="fields">
                <v-autocomplete v-model="fromTree" item-value="name" :items="dropdownTrees" label="Von |" outlined
                                :item-text="item => `${item.name}`" clearable hide-details></v-autocomplete>
                <v-autocomplete v-model="toTree" item-value="name" :items="dropdownTrees" label="Bis |" outlined
                                :item-text="item => `${item.name}`" clearable hide-details></v-autocomplete>
              </div>
            </div>

            <div class="task-name">
              <p class="custom-label">Massnahme</p>

              <div class="fields" @click="showPopupFunction">
                <v-text-field
                  outlined
                  hide-details
                  clearable
                  readonly
                  :value="finalWorkTypeSelection"
                  @click:clear="clearedWorktypeFIlter"
                >
                  <v-icon slot="append" color="white">
                    mdi-chevron-down
                  </v-icon>
                </v-text-field>
              </div>
            </div>

            <div class="filter-btns">
              <v-btn
                size="x-large"
                height="54px"
                color="#1db954"
                class="filter-btn"
                @click="fetchTasksWithParameters"
              >
                Filter
              </v-btn>
              <v-btn
                size="x-large"
                height="54px"
                class="clear"
                @click="resetFilter"
              >
                <v-icon>mdi mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row justify="end" v-if="!hideFilters">
          <v-col cols="6">
            <v-btn-toggle
              class="three-buttons"
              active-class="custom-active"
              mandatory
              v-model="taskTypeButtonActive"
            >
              <v-hover v-slot="{ hover }">
                <v-btn
                  size="x-large"
                  height="54px"
                  outlined
                  class="custom-outlined"
                  @click="onTaskFilter(TaskTypes.Open)"
                >
                  Offen
                </v-btn>
              </v-hover>

              <v-hover v-slot="{ hover }">
                <v-btn
                  size="x-large"
                  height="54px"
                  outlined
                  class="custom-outlined"
                  @click="onTaskFilter(TaskTypes.Closed)"
                >
                  Erledigt
                </v-btn>
              </v-hover>

              <v-hover v-slot="{ hover }">
                <v-btn
                  size="x-large"
                  height="54px"
                  outlined
                  class="custom-outlined"
                  @click="onTaskFilter(TaskTypes.All)"
                >
                  Gesamtplan
                </v-btn>
              </v-hover>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card :loading="isLoading">
      <BaumControlListDatatable
        :hideSelection="hideSelection"
        :headers="visibleHeaders"
        :tableData="tableDataWithYear"
        :showSelect="true"
        :singleSelect="false"
        :actions="[
          { id: 1, icons: require('../../../assets/images/icons/eye-outline.svg'), action: 'view', params: '' },
          {
            id: 2,
            icons: require('../../../assets/images/icons/edit-outline.svg'),
            action: 'createEditBaumK',
            params: ''
          },
          { id: 3, icons: require('../../../assets/images/icons/pencil-outline.svg'), action: 'edit', params: '' }
        ]"
        @createEditBaumK="createEditBKMethod"
        @edit="editTaskMethod"
        @view="viewBKMethod"
        @removeTasks="removeTasksAfterDelete"
        :userCanView="userCanView"
        :userCanEdit="userCanEdit"
        :userCanDelete="userCanDelete"
      />
    </v-card>

    <div class="popup" v-show="showPopup">
      <div class="popup-holder">
        <v-icon size="36" class="close-popup" @click="closePopupFunction"
        >mdi mdi-close</v-icon
        >
        <p class="title">Auswählen</p>

        <v-text-field
          class="search"
          hide-details
          placeholder="Suchen"
          v-model="workTypeSearchText"
          @keyup="searchWorkTypes"
        >
          <v-icon slot="append" color="white">
            mdi-magnify
          </v-icon>
        </v-text-field>

        <div class="alphabet">
          <v-chip-group
            v-model="selectedChar"
            active-class="green"
            column
            class="my-3"
          >
            <v-chip
              :key="letter"
              size="31"
              class="rounded-0 ma-1 custom-chip"
              v-for="letter in letters"
              :ripple="false"
              :class="selectedChar === letter ? 'green' : ''"
              @click="selectLetter(letter)"
              outlined
            >
              <span>{{ letter }}</span>
            </v-chip>
          </v-chip-group>
        </div>

        <div class="work-types" v-show="workTypes.length">
          <v-radio-group v-model="selectedWorktype">
            <div class="radio-wrapper">
              <v-radio
                v-for="(wt, index) in workTypes"
                :key="index"
                :label="wt.abbreviation + ', ' + wt.description"
                :value="wt.abbreviation"
                class="custom-radio"
                @click="radioClicked(wt)"
              ></v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Tasks from "@/consts/taskTypes";
import BaumControlListDatatable from "../../../components/custom_components/BaumControlListDatatable.vue";
import { eventBus } from "../../../main";
import axios from "axios";
import { TreeFilterConst, TreeInspectionConst } from '@/consts/Filters'
import DateInput from '../../../components/base/DateInput.vue'
import { format } from 'date-fns'
import { de as deLocale } from 'date-fns/locale'

export default {
  components: {
    BaumControlListDatatable,
    DateInput
  },
  props: {
    hideFilters: Boolean,
    passedTreeId: Number,
    hideSelection: Boolean,
    isTree: Boolean,
    allYears: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /* useraccess */
      userCanEdit: false,
      userCanView: false,
      userCanDelete: false,
      /* end of useraccess */

      isMobileViewport: false,
      showInfo: false,
      isLoading: false,
      years: [],
      headers: [
      { text: "Bak", value: "colorTypeId" },
        {
          text: "Etappe",
          align: "start",
          value: "date"
        },
        { text: "BaumID", value: "treeName" },
        { text: "Baumart", value: "treeType" },
        {
          text: "Massnahme",
          value: "workType",
          sortable: false
        },
        {
          text: "Intervall",
          value: "interval",
          sortable: false
        },
        {
          text: "Spez. Std",
          value: "specialHours",
          sortable: false
        },
        {
          text: "Bp1.Std",
          value: "normalHours",
          sortable: false
        },
        { text: "Mat.Fr.", value: "material", sortable: false },
        { text: "Datum", value: "finishDate" },
        {
          text: "Visum",
          value: "examinationFinishedUsers",
          sortable: false
        },
        {
          text: "Tage bis Versiegelung",
          value: "sealDays"
        },
         {
          text: "Info",
          value: "info"
        },
        { text: "", value: "buttons", align: "start", sortable: false }
      ],
      headersMobile: [
        {
          text: "Etappe",
          align: "start",
          value: "date",
          width: "120px"
        },
        { text: "BaumID", value: "treeName", width: "110px" },
        { text: "Baumart", value: "treeType", width: "110px" },
        {
          text: "Massnahme",
          value: "workType",
          width: "140px",
          sortable: false
        },
        {
          text: "Intervall",
          value: "interval",
          width: "70px",
          sortable: false
        },
        {
          text: "Spez. Std",
          value: "specialHours",
          width: "75px",
          sortable: false
        },
        {
          text: "Bp1.Std",
          value: "normalHours",
          width: "70px",
          sortable: false
        },
        { text: "Mat.Fr.", value: "material", width: "70px", sortable: false },
        { text: "Datum", value: "finishDate", width: "120px" },
        {
          text: "Visum",
          value: "examinationFinishedUsers",
          width: "95px",
          sortable: false
        },
        {
          text: "Tage bis Versiegelung",
          value: "sealDays"
        },
        {
          text: "Info",
          value: "info"
        },
        { text: "", value: "buttons", align: "start", sortable: false }
      ],
      tableData: [],
      year: null,
      taskType: 2,
      TaskTypes: null,
      selectedColor: null,
      colorOptions: [
        { text: 'Keine', value: null },
        { text: 'Rot', value: 'Red' },
        { text: 'Grün', value: 'Green' },
        { text: 'Blau', value: 'Blue' },
        { text: 'Gelb', value: 'Yellow' },
        { text: 'Grau', value: 'Gray' },
      ],
      taskTypeButtonActive: 0,
      showFilters: false,
      fromTree: "",
      toTree: "",
      fromDate: "",
      toDate: "",
      dropdownTrees: [],
      finalWorkTypeSelection: "",
      finalWorkTypeSelectionId: null,
      workTypes: [],
      showPopup: false,
      workTypeSearchText: "",
      selectedChar: null,
      letters: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      selectedWorktype: null,
    };
  },
  computed: {
    ...mapGetters(["inventarId", 'inventarSelectedYear', "getTreeItem", "getAreaItem", "getTreesInspectionsFilters", 'getSelectedTreeInspections', 'getRedirectTreeInspectionPageToMap']),
    currentUserType() {
      const token = JSON.parse(localStorage.getItem("token"));
      const users = JSON.parse(localStorage.getItem("userInfo")) || [];
      const currentUser = users.find(user => user.token === token) || users[0];
      return currentUser?.type;
    },
    visibleHeaders() {
      const headers = this.isMobileViewport ? this.headersMobile : this.headers;
      if (this.currentUserType !== 4) {
        return headers;
      }

      return headers.filter(header => !["specialHours", "normalHours", "material"].includes(header.value));
    },
    tableDataWithYear() {
      const currentYear = new Date().getFullYear();
      return this.tableData.map(row => ({
        ...row,
        year: row.date ? new Date(row.date).getFullYear() : currentYear,
      }));
    },
    orderedYearsWithAll() {
      let reversedYears = this.years.slice().reverse();
      return [{ text: 'Alle Jahre', value: 0 }, ...reversedYears.map(year => ({ text: year.toString(), value: year }))];
    },
    orderedYears() {
      return this.years.slice().reverse();
    },

  },
  created() {
    if (!this.allYears){
      const date = new Date();
      this.year = date.getFullYear();
    }
    else
      this.year = 0
  },
  async mounted() {
    if(this.inventarSelectedYear && !this.allYears){
      this.year = this.inventarSelectedYear
    }

    /* check viewportsizes */
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);

    this.setFilters()
    this.TaskTypes = Tasks;
    await this.fetchYears();
    await this.fetchTreesForDropdown()
    await this.fetchTasks();
    this.redirectPageToMap()
  },
  methods: {
    ...mapActions([
      "addTreeItem",
      "updateSelectedYear",
      "setTreeInspectionFilter",
      "resetTreeInspectionFilters",
      'setRedirectTreeInspectionPageToMap'
    ]),
    filtersTrigger() {
      this.showFilters = !this.showFilters;
    },
    onClearDateFrom() {
      this.fromDate = null;
      this.toDate = null;
    },
    onClearDateTo() {
      this.toDate = null;
    },
    showPopupFunction() {
      this.showPopup = true;
      this.fetchWorkTypes();
    },
    closePopupFunction() {
      this.showPopup = false;
      this.workTypes = [];
    },
    clearedWorktypeFIlter() {
      this.finalWorkTypeSelection = "";
      this.finalWorkTypeSelectionId = null;
      this.selectedWorktype = null;
    },
    selectLetter(letter) {
      this.selectedChar = letter;

      if (letter === this.previouslySelectedChar) {
        this.selectedChar = null;
      }
      this.previouslySelectedChar = this.selectedChar;

      if (this.selectedChar) {
        this.fetchWorkTypes(this.selectedChar);
      } else {
        this.fetchWorkTypes();
      }
      this.workTypeSearchText = "";
    },

    searchWorkTypes() {
      if (this.workTypeSearchText) {
        clearTimeout(this.searchTimeOut);
        this.searchTimeOut = setTimeout(() => {
          this.fetchWorkTypes(this.workTypeSearchText);
          clearTimeout(this.searchTimeOut);
        }, 300);
      } else {
        this.workTypes = [];
        this.fetchWorkTypes();
      }
      this.selectedChar = false;
      this.previouslySelectedChar = null;
    },
    async fetchTasksWithParameters(){
      const paramString = this.createParamString();

      eventBus.$emit("resetSelectedTasks");

      this.tableData = [];
      try {
        this.isLoading = true;
        const response = await axios.get(`/api/TreeExamination/GetAll/${paramString}`);

        /* check if there are data */
        if (Object.keys(response.data).length > 0) {
          this.tableData = response.data.result;

          /* change user privileges */
          this.userCanDelete = response.data.access.canDelete;
          this.userCanEdit = response.data.access.canEdit;
          this.userCanView = response.data.access.canView;
        }

        this.setFilterState()
      } catch (error) {
        console.log(error);
      }
      finally {
        this.isLoading = false;
      }
    },
    resetFilter() {
      this.fromDate = null;
      this.toDate = null;
      this.fromTree = null;
      this.toTree = null;
      this.finalWorkTypeSelection = "";
      this.finalWorkTypeSelectionId = null;
      this.selectedWorktype = null;
      this.toDateFormatted = null;
      this.fromDateFormatted = null;
      this.fetchTasks();
      this.resetTreeInspectionFilters()
    },
    radioClicked(wt) {
      this.finalWorkTypeSelection = wt.abbreviation;
      this.finalWorkTypeSelectionId = wt.id;
      this.showPopup = false;
    },
    async fetchTreesForDropdown(){
      try {
        const response = axios.get(`/api/Tree/GetAllWithParameters/${this.inventarId}`)
          .then(res => {
            if(res.data){
              this.dropdownTrees = res.data
            }
          })
      } catch (error) {
        console.error('Error on fetching trees for dropdown', error);
      }
    },
    updateIsMobile() {
      const width = window.innerWidth;
      if (width < 1400) {
        this.isMobileViewport = true;
      } else {
        this.isMobileViewport = false;
      }
    },

    async fetchYears() {
      try {
        const response = await axios.get(
          `/api/Inventory/GetYearsByInventory/${this.inventarId}`
        );
        this.years = response.data;
      } catch (error) {
        console.log(error);
        this.hasError = true;
      }
    },

    async fetchWorkTypes(name) {
      let endpoint = `/api/WorkType/GetAll`;
      if (name) {
        endpoint += `?name=${name}`;
      }

      try {
        const response = await axios.get(endpoint);

        this.workTypes = response.data;
      } catch (error) {
        console.error('Error on fetching work types', error);
      }
    },

    async fetchTasks(resetSelected = false) {
      const paramString = this.createParamString();

      if (resetSelected)
        eventBus.$emit("resetSelectedTasks");

      try {
        this.isLoading = true;
        const response = await axios.get(`/api/TreeExamination/GetAll/${paramString}`);

        /* check if there are data */
        if (Object.keys(response.data).length > 0) {
          this.tableData = response.data.result;

          /* change user privileges */
          this.userCanDelete = response.data.access.canDelete;
          this.userCanEdit = response.data.access.canEdit;
          this.userCanView = response.data.access.canView;
        }

      } catch (error) {
        console.log(error);
        this.hasError = true;
      }
      finally {
        this.isLoading = false;
      }
    },

    onTaskFilter(tasktype) {
      this.taskType = tasktype;
      this.setActiveTaskTypeActiveBtn(tasktype);
      this.tableData = [];
      this.fetchTasks(true);
      this.setFilterState()
    },

    yearChange(year) {
      // this.updateSelectedYear(year);
      this.year = year;
      this.tableData = [];
      this.fetchTasks(true);
      this.setFilterState()
    },
    colorChange(color){
      this.selectedColor = color;
      this.tableData = [];
      this.fetchTasks(true);
      this.setFilterState()
    },

    createParamString() {
      const params = [];

      if (
        this.fromDate !== null &&
        this.fromDate !== undefined &&
        this.fromDate !== ""
      ) {
        params.push(`FromDate=${this.fromDate}`);
      }

      if (
        this.toDate !== null &&
        this.toDate !== undefined &&
        this.toDate !== ""
      ) {
        params.push(`ToDate=${this.toDate}`);
      }

      if (
        this.taskType !== null &&
        this.taskType !== undefined &&
        this.taskType !== ""
      ) {
        params.push(`TaskType=${this.taskType}`);
      }

      if (
        this.fromTree !== null &&
        this.fromTree !== undefined &&
        this.fromTree !== ""
      ) {
        params.push(`FromTree=${this.fromTree}`);
      }

      if (
        this.toTree !== null &&
        this.toTree !== undefined &&
        this.toTree !== ""
      ) {
        params.push(`ToTree=${this.toTree}`);
      }

      if (
        this.passedTreeId !== null &&
        this.passedTreeId !== undefined &&
        this.passedTreeId !== ""
      ) {
        params.push(`TreeId=${this.passedTreeId}`);
      }

      if (
        this.finalWorkTypeSelectionId !== null &&
        this.finalWorkTypeSelectionId !== undefined &&
        this.finalWorkTypeSelectionId !== ""
      ) {
        params.push(`WorkTypeId=${this.finalWorkTypeSelectionId}`);
      }

      if(
        this.selectedColor !== null &&
        this.selectedColor !== undefined &&
        this.selectedColor !== ""
      ){
        params.push(`ColorType=${this.selectedColor}`);

      }
      if(this.year == 0){
        params.push(`AllYears=true`)
      }

      return this.inventarId + "/" + this.year + "?" + params.join("&");
    },

    editTaskMethod(item) {
      sessionStorage.setItem('forceReload', 'true');
      this.$router.replace({ path: '/empty' }).then(() => {
      this.$router.push({
        name: "Pflegemassnahme bearbeiten",
        params: {
          taskId: item.id,
          canDelete: this.userCanDelete,
          year: this.year == 0 ? item.year  : this.year,
          fromBaumKontroll: true
        }
      });
    });
    },

    createEditBKMethod(item) {
      sessionStorage.setItem('forceReload', 'true');
      this.$router.replace({ path: '/empty' }).then(() => {
        this.$router.push({
          name: "BaumKontrollDetails",
          params: {
            taskId: item.id,
            treeId: item.treeId,
            treeName: item.treeName,
            treeExaminationId: item.treeExaminationId,
            isEditBK: item.isFinished,
            isSealed: item.isSealed,
            treeType: item.treeType,
            viewOnly: false,
            year: this.year == 0 ? item.year : this.year
          }
        });
      });
    },

    viewBKMethod(item) {
    if(!item.finishDate){
      this.$router.push({
            name: "Pflegeplan Eintrag",
            params: { taskId: item.id, year: this.year == 0 ? item.year : this.year, canEdit: false }
          });
    } else{
      sessionStorage.setItem('forceReload', 'true');
      this.$router.replace({ path: '/empty' }).then(() => {
      this.$router.push({
        name: "BaumKontrollDetails",
        params: {
          taskId: item.id,
          year: this.year == 0 ? item.year : this.year,
          treeId: item.treeId,
          treeName: item.treeName,
          treeExaminationId: item.treeExaminationId,
          isSealed: item.isSealed,
          isEditBK: item.isFinished,
          treeType: item.treeType,
          viewOnly: true
        }
      });
      });
    }
    },

    createNewTask() {
      if (!this.userCanEdit) {
        return;
      }

      this.$router.push({
        name: "Neue Pflegemassnahme",
        params: {
          fromBaumKontroll: true, 
          treeId: this.passedTreeId,
          treeName: this.getTreeItem?.name || "",
          isTree: this.isTree
        }
      });
    },
    viewSelectedItemOnMap() {
      if (this.tableData.length > 0 && this.getSelectedTreeInspections) {
        const selectedIds = this.getSelectedTreeInspections.map(item => item.id);
        const items = this.tableData.filter(element => selectedIds.includes(element.id));
        const treeItems = items.map(el => el)
        this.addTreeItem(treeItems);

        if (this.getAreaItem && this.getTreeItem) {
          this.setRedirectTreeInspectionPageToMap(true)
          this.$router.push({
            name: "Auswahl"
          });
        }
      } else {
        this.showInfo = !this.showInfo;
            setTimeout(() => {
          this.showInfo = false;
        }, 2000);
      }
    },
    removeTasksAfterDelete(taskIds){
      this.tableData = this.tableData.filter(item => !taskIds.includes(item.id));
    },
    setActiveTaskTypeActiveBtn(tasktype){
      this.taskTypeButtonActive = tasktype === Tasks.Open ? 0 : tasktype === Tasks.Closed ? 1 : tasktype === Tasks.All ? 2 : 0;
    },
    setFilters(){
      // this.year = this.getTreesInspectionsFilters[TreeInspectionConst.Year]
      this.selectedColor = this.getTreesInspectionsFilters[TreeInspectionConst.Color]
      this.fromDate = this.getTreesInspectionsFilters[TreeInspectionConst.DateFrom]
      this.fromDateFormatted = this.fromDate ? format(new Date(this.fromDate),'dd MMMM yyyy', {locale:deLocale}) : null;
      this.toDate = this.getTreesInspectionsFilters[TreeInspectionConst.DateTo]
      this.toDateFormatted = this.toDate ? format(new Date(this.toDate),'dd MMMM yyyy', {locale:deLocale}) : null;
      this.fromTree = this.getTreesInspectionsFilters[TreeInspectionConst.BaumIdFrom]
      this.toTree = this.getTreesInspectionsFilters[TreeInspectionConst.BaumIdTo]
      this.finalWorkTypeSelection = this.getTreesInspectionsFilters[TreeInspectionConst.Measure];
      this.finalWorkTypeSelectionId = this.getTreesInspectionsFilters[TreeInspectionConst.MeasureId];
      this.taskType = this.getTreesInspectionsFilters[TreeInspectionConst.TaskType]
      this.setActiveTaskTypeActiveBtn(this.taskType)

      if (this.fromDate || this.toDate || this.fromTree || this.toTree || this.finalWorkTypeSelection)
        this.showFilters = true
    },
    setFilterState(){
      // this.setTreeInspectionFilter({filter: TreeInspectionConst.Year, value: this.year})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.Color, value: this.selectedColor})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.TaskType, value: this.taskType})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.DateFrom, value: this.fromDate})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.DateTo, value: this.toDate})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.BaumIdFrom, value: this.fromTree})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.BaumIdTo, value: this.toTree})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.Measure, value: this.finalWorkTypeSelection})
      this.setTreeInspectionFilter({filter: TreeInspectionConst.MeasureId, value: this.finalWorkTypeSelectionId})
    },
    redirectPageToMap(){
      if (this.getRedirectTreeInspectionPageToMap){
        this.viewSelectedItemOnMap()
      }
    }
  }
};
</script>

<style>
.first-row {
  .karte {
    margin-right: 10px;
    position: relative !important;
  }
  .information {
    position: absolute;
    padding: 5px !important;
    color: black !important;
    background: #fff !important;
    position: absolute !important;
    top: -31px !important;
    width: 400px !important;
    z-index: 99999;
  }
}

.filters-row {
  .filters-holder {
    display: flex;
    align-items: flex-end;
    gap: 30px;
    margin-bottom: 30px;

    .custom-label {
      display: block;
      flex-wrap: nowrap;
    }

    .from-to-tree,
    .from-to-dates,
    .task-name {
      display: flex;
      justify-content: flex-end;
      flex-direction: column;

      .fields {
        display: flex;
        gap: 30px;
      }
    }

    .filter-btns {
      display: flex;
      align-items: flex-end;
      gap: 30px;

      .filter-btn {
        color: #000;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        text-transform: none;
        background-color: #1db954;

        .v-btn__content {
          i {
            display: block;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
